// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import wechat from '@/common/js/wechat.js'
import axios from 'axios'
import MintUI from 'mint-ui'
import store from './store/index.js'
import Url from '@/common/js/url.js'
import Utils from '@/common/js/utils'
// import Vconsole from 'vconsole'
import '@/common/js/filter.js'
import 'mint-ui/lib/style.css'
import 'mint-ui/lib/spinner/style.css'
import 'mint-ui/lib/toast/style.css'
/* eslint-disable no-new */

/* --------- */
// let vconsole = new Vconsole()
// export default vconsole
Vue.config.productionTip = false
Vue.use(wechat)
Vue.use(MintUI)

// 处理微信分享出来的地址，微信会添加多余参数
function getCorrectUrl () {
  var baseUrl = Url.api + 'wechat/index.html'
  var originUrl = window.location.href
  var redirectUrl = originUrl.split('#/')[1]
  return (baseUrl + '#/' + redirectUrl)
}

var deviceId = localStorage.getItem('deviceId');
if (!deviceId) {
  deviceId = 'device_' + Math.random().toString().replace('.', '');
  localStorage.setItem("deviceId", deviceId);
}

// 微信授权
var redirectLogin = function () {
  sessionStorage.removeItem('openId')
  let loginUrl = Url.api + 'memberapi/wx/auth/initOpenId.do?from=' + from + '&redirectUrl=' + redirectUrl + '&actP=' + actP +
    '&userAgent=' + encodeURIComponent(navigator.userAgent) + '&deviceId=' + deviceId
  location.replace(loginUrl)
}
var redirectUrl = (location.href.indexOf('from') > -1) ? location.href.split('?from')[0].replace('#', '%23') : location.href.replace('#', '%23')
// 获取openId
var openId = Utils.GetQueryString('?' + location.hash.split('?')[1], 'openId')

// 获取authtoken
var authToken = Utils.GetQueryString('?' + location.hash.split('?')[1], 'authtoken')

// 获取用户登录状态
var wxUserStatus = Utils.GetQueryString('?' + location.hash.split('?')[1], 'status')
sessionStorage.setItem('wxUserStatus', wxUserStatus)

// 如果没有门店ID，从地址栏获取，如果已经存储了门店Id，则不需要
if (!sessionStorage.getItem('storeId') || sessionStorage.getItem('storeId') === 'null') {
  var storeId = Utils.GetQueryString('?' + location.hash.split('?')[1], 'storeId')
  sessionStorage.setItem('storeId', storeId)
}
// 获取来自哪个公众号
var from = Utils.GetQueryString('?' + location.hash.split('?')[1], 'from')
if (sessionStorage.getItem('from') === '' || sessionStorage.getItem('from') === null) {
  sessionStorage.setItem('from', from)
}
// 区分活动页面是是从公众号直接打开还是从外部链接打开，需要手动在连接后面配置actP参数
// actP='inline' 则为公众号进入 actP='out' 则为外部进入
var actP = Utils.GetQueryString('?' + location.hash.split('?')[1], 'actP')
if (sessionStorage.getItem('actP') === '' || sessionStorage.getItem('actP') === null) {
  sessionStorage.setItem('actP', actP)
}
// 设置测试环境token，部署到测试、生产需要注释
//sessionStorage.setItem('authtoken', 'oX2Rs05IZoZKnIq4fxpIh47ZHmcM')
//sessionStorage.setItem('storeId', '1')
//sessionStorage.setItem('wxUserStatus', '2')

// 设置测试环境token，部署到测试、生产需要注释
if (process.env.NODE_ENV === 'development') {
  if (!sessionStorage.getItem('authtoken')) {
    authToken = '654321'
  } else {
    authToken = sessionStorage.getItem('authtoken');
  }
  if (!openId) {
    openId = '123456'
  }
}

// axios过滤器
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  // 设置基础参数
  if (config.params) {
    config.params.storeId = sessionStorage.getItem('storeId')
    config.params.appVersion = '1.0'
    config.params.imei = ''
    config.params.osVersion = ''
    config.params.platform = 'weixin'
  }
  if (sessionStorage.getItem('authtoken') && sessionStorage.getItem('authtoken') !== 'null') {
    config.headers['authtoken'] = sessionStorage.getItem('authtoken')
  }
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

//  切换路由需要更新重新验证config配置
router.afterEach(function (route) {
  if (route.meta.title) {
    document.title = route.meta.title // 设置文档标题
  }
  var configUrl = location.href.split('#')[0]
  axios.get(Url.api + 'payapi/wx/config.do', {
    params: {
      storeId: sessionStorage.getItem('storeId'),
      configUrl: encodeURIComponent(configUrl)
    }
  }).then(res => {
    let data = res.data
    Vue.wechat.config(data)
  }).catch(() => {})
})

router.beforeEach((to, from, next) => {
  const wxUserStatus = sessionStorage.getItem('wxUserStatus')
  // 需要判断wxUserStatus的页面
  const needLoginRouteList = ['/order/all', '/mine', '/coupon/gift', '/myNewActivity', '/rights', '/myCourse/open', '/note/course', '/getCoupon/1']
  // console.log('to:', to.path)
  if (needLoginRouteList.includes(to.path)) {
    if (wxUserStatus === '1') {
      next('/bind')
    } else if (wxUserStatus === '2') {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})
// 生产环境判断
if (authToken || openId) {
  sessionStorage.setItem('authtoken', authToken)
  sessionStorage.setItem('openId', openId)
  new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: {
      App
    }
  })
} else if (sessionStorage.getItem('authtoken') || sessionStorage.getItem('openId')) {
  new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: {
      App
    }
  })
} else {
  if (window.location.href.indexOf('groupmessage') > -1 || window.location.href.indexOf('singlemessage') > -1 || window.location.href.indexOf('timeline') > -1) {
    // 微信分享出来的链接
    location.replace(getCorrectUrl())
  } else {
    redirectLogin()
  }
}



// WEBPACK FOOTER //
// ./src/main.js